import React from 'react';
import Summary from '@/components/Summary';
import { CopilotValue9ProductInfo } from '@/stores/types/copilotValue';

// interface ProductInfo {
//   name: string;
//   code: string;
//   type: string;
//   establishDate: string;
//   scale: string;
//   managementFee: string;
//   riskLevel: string;
//   riskLevelColor: string;
//   fundManager: string;
//   tenure: string;
//   minPurchase: string;
// }

// interface BasicInfoCompProps {
//   selected?: boolean;
//   onSelectChange?: (checked: boolean) => void;
// }

const BasicInfoComp: React.FC<any> = ({ selected = false, selectChange, totalData, type }) => {
  const productInfo = totalData?.product_info || [];
  const product1: CopilotValue9ProductInfo = productInfo[0] || {};
  const product2: CopilotValue9ProductInfo = productInfo[1] || {};

  // 获取风险等级颜色
  const getRiskLevelColor = (riskLevel: string) => {
    if (riskLevel?.includes('中高风险')) return 'text-red-600';
    if (riskLevel?.includes('中低风险')) return 'text-blue-600';
    if (riskLevel?.includes('中等风险')) return 'text-orange-600';
    return 'text-gray-600';
  };

  const fields = [
    { key: '产品名称', label: '产品' },
    { key: '基金代码', label: '基金代码' },
    { key: '基金类型', label: '基金类型' },
    { key: '成立时间', label: '成立时间' },
    { key: '规模', label: '基金规模' },
    { key: '管理费率', label: '管理费率' },
    { key: '风险等级', label: '风险等级' },
    { key: '基金经理', label: '基金经理' },
    { key: '任职年限', label: '任职年限' },
    { key: '跟踪指数', label: '跟踪指数' }
  ];

  return (
    <div className="mb-3 flex flex-col gap-3 rounded-lg border border-gray-200 bg-white p-3">
      {/* 标题行 */}
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-2">
          <div className="custom-checkbox">
            <input
              type="checkbox"
              checked={selected}
              onChange={e => selectChange?.(type, e.target.checked)}
              className="h-4 w-4"
              id="customcheckbox18"
            />
            <label htmlFor="customcheckbox18" />
          </div>
          <span className="text-base font-semibold text-gray-900">基础信息对比</span>
        </div>
      </div>

      {/* 对比表格 */}
      <div className="flex overflow-hidden rounded-lg border border-gray-200">
        {/* 字段列 */}
        <div className="flex w-[93px] flex-col">
          <div className="rounded-tl-lg bg-[#F5F5F5] px-2 py-1">
            <span className="text-xs font-semibold text-textPrimary">产品</span>
          </div>
          {fields.slice(1).map(field => (
            <div key={field.key} className="bg-white px-2 py-1">
              <span className="text-xs text-gray-900">{field.label}</span>
            </div>
          ))}
        </div>

        {/* 产品1列 */}
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="truncate bg-[#5959EB1A] px-2 py-1">
            <span
              className="w-full truncate text-xs font-semibold text-colorPrimaryText"
              title={product1.产品名称 || '无'}
            >
              {product1.产品名称 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span
              className="truncate text-xs text-gray-900"
              title={product1.基金代码 || product1.产品代码 || '无'}
            >
              {product1.基金代码 || product1.产品代码 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span className="text-xs text-gray-900" title={product1.基金类型 || '无'}>
              {product1.基金类型 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span
              className="text-xs text-gray-900"
              title={product1.成立时间 || product1.成立日期 || '无'}
            >
              {product1.成立时间 || product1.成立日期 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span className="text-xs text-gray-900" title={product1.基金规模_万元 || '无'}>
              {product1.基金规模_万元
                ? `${Number(product1.基金规模_万元).toLocaleString('zh-CN')}万元`
                : '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span className="text-xs text-gray-900" title={product1.管理费率 || '无'}>
              {product1.管理费率 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span
              className={`text-xs font-semibold ${getRiskLevelColor(
                product1.风险等级 || product1.基金风险等级
              )}`}
              title={product1.风险等级 || product1.基金风险等级 || '无'}
            >
              {product1.风险等级 || product1.基金风险等级 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span className="text-xs text-gray-900" title={product1.基金经理 || '无'}>
              {product1.基金经理 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span className="text-xs text-gray-900" title={product1.任职年限 || '无'}>
              {product1.任职年限 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#F2F7FF80] px-2 py-1">
            <span className="text-xs text-gray-900" title={product1.跟踪指数 || '无'}>
              {product1.跟踪指数 || '无'}
            </span>
          </div>
        </div>

        {/* 产品2列 */}
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="truncate rounded-tr-lg bg-[#FA8C161A] px-2 py-1">
            <span
              className="w-full truncate text-xs font-semibold text-orangeWeightText"
              title={product2.产品名称 || '无'}
            >
              {product2.产品名称 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span
              className="text-xs text-gray-900"
              title={product2.基金代码 || product2.产品代码 || '无'}
            >
              {product2.基金代码 || product2.产品代码 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span className="text-xs text-gray-900" title={product2.基金类型 || '无'}>
              {product2.基金类型 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span
              className="text-xs text-gray-900"
              title={product2.成立时间 || product2.成立日期 || '无'}
            >
              {product2.成立时间 || product2.成立日期 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span className="text-xs text-gray-900" title={product2.基金规模_万元 || '无'}>
              {product2.基金规模_万元
                ? `${Number(product2.基金规模_万元).toLocaleString('zh-CN')}万元`
                : '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span className="text-xs text-gray-900" title={product2.管理费率 || '无'}>
              {product2.管理费率 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span
              className={`text-xs font-semibold ${getRiskLevelColor(
                product2.风险等级 || product2.基金风险等级
              )}`}
              title={product2.风险等级 || product2.基金风险等级 || '无'}
            >
              {product2.风险等级 || product2.基金风险等级 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span className="text-xs text-gray-900" title={product2.基金经理 || '无'}>
              {product2.基金经理 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span className="text-xs text-gray-900" title={product2.任职年限 || '无'}>
              {product2.任职年限 || '无'}
            </span>
          </div>
          <div className="truncate bg-[#FFF7E699] px-2 py-1">
            <span className="text-xs text-gray-900" title={product2.跟踪指数 || '无'}>
              {product2.跟踪指数 || '无'}
            </span>
          </div>
        </div>
      </div>

      {/* AI总结部分 */}
      <Summary
        title="AI总结-投资策略"
        content={totalData?.投资策略 || '无'}
        isShowSuggestions={false}
      />
    </div>
  );
};

export default BasicInfoComp;
